const Users = {
  MANAGER: "MANAGER",
};

export default Object.freeze(Users);
